export const environment = {
  production: false,
  apiUrl: 'https://dev-api.biyaheko.com/',
  flightApi: 'https://dev-booking.biyaheko.com/',
  imageUrl: 'https://biyaheko-dev.s3.amazonaws.com/',
  logoUrl: 'assets/images/biyaheko.png',
  client: 'Biyaheko',
  clientAbbr: 'BYK',
  // Price / number format for BYK: 'en-US' -> 100,000.00 (Indian format would be 'en-IN' -> 1,00,000.00)
  numberFormat: 'en-US',
  // Decimal places for every price (2 -> 1,500.00, 0 -> 1,500)
  numberDecimals: 2,
  clientShort: 'Biyaheko',
  showOrgSettingsAllTabs: false,
  showWhitelabel: true,
  logoHeight: '26',
  whitelabelCustomJs: 'https://book-staging-bucket.s3.ap-south-1.amazonaws.com/whitelabel/custom.js',
  whitelabelStyleCss: 'https://book-staging-bucket.s3.ap-south-1.amazonaws.com/whitelabel/style.css'
};